class TeamAuthorizationDTO {
    constructor(data) {
        this.data = this.validateData(data);
    }

    validateData(data) {
        if (data && typeof data === "object" && !Array.isArray(data)) {
            return data;
        }
        console.error("Invalid data format: component data must be an object.");
        return {};
    }
}

export default TeamAuthorizationDTO;
